/* One homepage-style search/cart implementation, used by both layouts.
   Native Shopify endpoints remain the only source of cart and search data. */
(() => {
  const host = document.getElementById('giesto-header-surfaces');
  if (!host || host.dataset.ready) return;
  host.dataset.ready = 'true';
  const tr = host.dataset.locale.startsWith('tr');
  const text = (turkish, english) => tr ? turkish : english;
  // Shopify's route root can retain /en from the buyer's language cookie on
  // a Turkish page. Keep requests and result links in the rendered language.
  const prefix = tr ? '' : host.dataset.root.replace(/\/$/, '') || '/en';
  const local = path => prefix + '/' + String(path).replace(/^(?:\/en)+(?=\/|$)/, '').replace(/^\//, '');
  const search = host.querySelector('.ghs-search'), cart = host.querySelector('.ghs-cart'), account = host.querySelector('.ghs-account');
  const input = search.querySelector('input[name=q]');
  const searchForm = search.querySelector('[data-ghs-search-form]');
  searchForm.action = local('/search');
  const searchClear = search.querySelector('[data-ghs-search-clear]');
  const results = search.querySelector('[data-ghs-results]'), initialResults = results.innerHTML;
  const searchStatus = search.querySelector('[data-ghs-search-status]');
  const cartStatus = cart.querySelector('[data-ghs-cart-status]');
  const itemsPanel = cart.querySelector('.ghs-cart__items');
  const recent = cart.querySelector('[data-ghs-recent]');
  const recentRail = cart.querySelector('[data-ghs-recent-rail]');
  const checkout = cart.querySelector('[data-ghs-checkout]');
  checkout.href = local('/checkout');
  let trigger, searchOrigin, previousOverflow, restoring = false, searchTimer, searchRequest, cartData, activeTab = 'cart', cartRequest = 0, recentRequest = 0, lastSearchQuery = '';
  // The delivery promise. `giesto-free-shipping.liquid` is the only place these
  // amounts are read from, so the drawer cannot disagree with the product page
  // or the cart page about where the threshold sits or what delivery costs
  // below it. Both are in minor units.
  const freeShippingThreshold = Number(host.dataset.freeShippingThreshold) || 0;
  const shippingFee = Number(host.dataset.shippingFee) || 0;
  const money = cents => new Intl.NumberFormat(tr ? 'tr-TR' : 'en-GB', {style:'currency', currency:cartData?.currency || host.dataset.currency || 'TRY'}).format(cents / 100);
  function element(tag, className, value) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (value !== undefined) node.textContent = value;
    return node;
  }
  // Icons are the archived ARKET sprite paths, not redrawn controls.
  function icon(name) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    const use = document.createElementNS('http://www.w3.org/2000/svg','use');
    use.setAttribute('href',host.dataset.icons + '#' + name);
    svg.setAttribute('aria-hidden','true');svg.append(use);return svg;
  }
  function productLink(path) {
    const url = new URL(path, window.location.origin);
    return local(url.pathname) + url.search;
  }
  function readRecent() {
    try {
      const value = JSON.parse(localStorage.getItem('viewedProductDetails') || '[]');
      return Array.isArray(value) ? value.filter(item => item?.handle).slice(0, 8) : [];
    } catch { return []; }
  }
  function rememberCurrentProduct() {
    const id = host.dataset.currentProductId, handle = host.dataset.currentProductHandle;
    if (!id || !handle) return;
    try {
      const details = readRecent().filter(item => String(item.id) !== String(id) && item.handle !== handle);
      details.unshift({id, handle});
      localStorage.setItem('viewedProductDetails', JSON.stringify(details.slice(0, 8)));
      const ids = details.map(item => String(item.id));
      localStorage.setItem('viewedProducts', JSON.stringify(ids));
    } catch { /* Recent products are optional when storage is unavailable. */ }
  }
  /* The drawer slides in from the edge it is docked to, as the archived
     315kb00pg1dzm.js does: the panel animates `right` (desktop) or `bottom`
     (mobile) from -100% to 0 over .15s cubic-bezier(.4,0,.2,1), with the beige
     overlay fading in on the same curve. The CSS holds both positions; this
     only flips `data-ghs-open` a frame after showModal(), so the closed
     position gets painted first and the transition has somewhere to run from. */
  const DRAWER_TRANSITION = 150;
  const closing = new Set();
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  function show(dialog, origin, modal = true) {
    if (dialog.open) {
      // Re-opening mid-close: catch the panel and send it back out.
      if (closing.delete(dialog)) dialog.setAttribute('data-ghs-open','');
      return;
    }
    trigger = origin;
    for (const other of [search, cart, account]) if (other?.open) other.close();
    document.querySelector('giesto-canonical-header')?.closeMobileMenu?.();
    previousOverflow = document.documentElement.style.overflow;
    if (modal) document.documentElement.style.overflow = 'hidden';
    if (modal) dialog.showModal(); else dialog.show();
    if (reducedMotion()) {dialog.setAttribute('data-ghs-open','');return;}
    requestAnimationFrame(() => requestAnimationFrame(() => {if (dialog.open) dialog.setAttribute('data-ghs-open','');}));
  }
  function close(dialog) {
    if (!dialog.open || closing.has(dialog)) return;
    dialog.removeAttribute('data-ghs-open');
    if (reducedMotion()) {restoring = true;dialog.close();return;}
    closing.add(dialog);
    setTimeout(() => {
      if (!closing.delete(dialog)) return; // show() caught it on the way out
      if (dialog.open) {restoring = true;dialog.close();}
    }, DRAWER_TRANSITION);
  }
  function syncSearchOrigin(value) {
    if (!searchOrigin?.isConnected) return;
    searchOrigin.value = value;
    searchOrigin.dispatchEvent(new Event('input', {bubbles:true, composed:true}));
  }
  window.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    if (document.querySelector('dialog[open]:not(.ghs-dialog)')) return;
    const dialog = [search, cart, account].find(item => item?.open);
    if (!dialog) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (dialog === search && input.value) {
      input.value = '';
      lastSearchQuery = '';
      syncSearchOrigin('');
      updateSearch();
      return;
    }
    close(dialog);
  }, true);
  for (const dialog of [search, cart, account]) {
    if (!dialog) continue;
    dialog.querySelector('[data-ghs-close]')?.addEventListener('click', () => close(dialog));
    dialog.addEventListener('cancel', event => {event.preventDefault();close(dialog);});
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close(dialog);
    });
    dialog.addEventListener('close', () => {
      closing.delete(dialog);
      dialog.removeAttribute('data-ghs-open');
      if (dialog !== account) document.documentElement.style.overflow = previousOverflow || '';
      restoring = true;
      if (trigger?.isConnected) trigger.focus({preventScroll:true});
      queueMicrotask(() => { restoring = false; });
    });
  }
  function openSearch(origin) {
    show(search, origin);
    searchOrigin = origin instanceof HTMLInputElement ? origin : null;
    input.value = searchOrigin?.value || lastSearchQuery;
    input.focus();
    updateSearch();
  }
  // Capture before the archived React listeners and before shadow-root listeners.
  // composedPath gives the actual source control in either header.
  window.addEventListener('click', event => {
    if (event.composedPath().includes(host)) return;
    const nodes = event.composedPath().filter(node => node instanceof Element);
    const cartButton = nodes.find(node => node.matches('[data-testid="header-cart"]'));
    if (cartButton) {
      event.preventDefault(); event.stopImmediatePropagation();
      activeTab = 'cart'; show(cart, cartButton); loadCart(); return;
    }
    const accountButton = nodes.find(node => node.matches('[data-testid="header-account"]'));
    if (accountButton) {
      event.preventDefault();event.stopImmediatePropagation();
      if (account.open) {close(account);return;}
      const header = document.querySelector('#header-group') || document.querySelector('giesto-canonical-header');
      const accountTop = Math.max(0, header?.getBoundingClientRect().bottom || 0) + 'px';
      account.style.top = accountTop;account.style.setProperty('--ghs-account-top', accountTop);
      show(account, accountButton, false);return;
    }
    if (account?.open && !nodes.includes(account)) close(account);
    const searchButton = nodes.find(node => node.matches('header input[type="search"],header input[name="q"],[data-testid="header-search"]'));
    if (searchButton && !restoring) {event.preventDefault();event.stopImmediatePropagation();openSearch(searchButton);}
  }, true);
  const captureSearchFocus = event => {
    if (event.composedPath().includes(host)) return;
    const field = event.composedPath().find(node => node instanceof Element && node.matches('header input[type="search"],header input[name="q"]'));
    if (!field) return;
    // React listens to focusin, while the native shadow header uses focus.
    // Block both, including the focus restored when closing the dialog.
    event.stopImmediatePropagation();
    if (!restoring && !search.open) openSearch(field);
  };
  window.addEventListener('focus', captureSearchFocus, true);
  window.addEventListener('focusin', captureSearchFocus, true);
  async function updateSearch() {
    clearTimeout(searchTimer); searchRequest?.abort();
    const query = input.value.trim();
    lastSearchQuery = input.value;
    syncSearchOrigin(input.value);
    searchClear.hidden = !query;
    searchForm.toggleAttribute('data-has-query', Boolean(query));
    search.toggleAttribute('data-has-query', Boolean(query));
    const all = search.querySelector('[data-ghs-search-all]');
    all.hidden = !query;
    all.href = local('/search') + '?q=' + encodeURIComponent(query) + '&type=product';
    searchStatus.textContent = '';
    search.querySelector('[data-ghs-results-label]').textContent = query ? text('ARAMA SONUÇLARI','SEARCH RESULTS') : text('SİZİN İÇİN SEÇTİKLERİMİZ','CURATED FOR YOU');
    if (!query) { results.innerHTML = initialResults; return; }
    searchTimer = setTimeout(async () => {
      searchRequest = new AbortController();
      try {
        const response = await fetch(local('/search/suggest.json') + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=4', {signal:searchRequest.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (input.value.trim() !== query) return;
        results.replaceChildren();
        for (const item of data.resources?.results?.products || []) {
          const link = element('a'); link.href = productLink(item.url);
          const imageUrl = item.featured_image?.url || item.image;
          if (imageUrl) {const img = element('img');img.src = imageUrl;img.alt = '';link.append(img);}
          link.append(element('span', '', item.title)); results.append(link);
        }
        if (!results.children.length) searchStatus.textContent = text('Eşleşen ürün bulunamadı.','No matching products.');
      } catch (error) {
        if (error.name === 'AbortError') return;
        searchStatus.textContent = text('Tüm sonuçları görmek için Enter tuşuna basın.','Press Enter to view all results.');
      }
    }, 500);
  }
  input.addEventListener('input', updateSearch);
  searchClear.addEventListener('click', () => {
    input.value = '';
    lastSearchQuery = '';
    syncSearchOrigin('');
    input.focus();
    updateSearch();
  });
  const headerControl = selector => document.querySelector('giesto-canonical-header')?.shadowRoot?.querySelector(selector) || document.querySelector(selector);
  function syncCartCount(count, attempt = 0) {
    const button = headerControl('[data-testid="header-cart"]');
    if (!button) {
      if (attempt < 30) requestAnimationFrame(() => syncCartCount(count, attempt + 1));
      return;
    }
    let holder = button.querySelector(':scope > span');
    if (!holder) {holder=element('span');button.append(holder);}
    holder.replaceChildren();
    if (count > 0) {
      const badge=element('span');badge.dataset.ghsCartBadge='';badge.setAttribute('aria-hidden','true');
      badge.style.cssText='position:absolute;top:-.4rem;right:1rem;transform:translateX(100%);display:inline-block;box-sizing:border-box;min-width:1.6rem;height:1.6rem;padding:0 .4rem;border-radius:999px;background:rgb(8,81,189);color:white;text-align:center;font:1.2rem/1.8rem var(--font-small-caps,ga-small-caps),Arial,sans-serif;letter-spacing:-.02em';
      const number=element('span','',count > 99 ? '99+' : String(count));number.style.cssText='display:inline-block;transform:translateY(-.25rem)';badge.append(number);holder.append(badge);
    }
    button.setAttribute('aria-label',text('Sepetim','My bag') + (count ? ` (${count})` : ''));
  }
  function syncAccountState(attempt = 0) {
    const button = headerControl('[data-testid="header-account"]');
    if (!button) {
      if (attempt < 30) requestAnimationFrame(() => syncAccountState(attempt + 1));
      return;
    }
    button.querySelector('[data-ghs-customer-dot]')?.remove();
    if (host.dataset.customer !== 'true') return;
    button.style.position = 'relative';
    const dot = element('span');
    dot.dataset.ghsCustomerDot = '';
    dot.setAttribute('aria-hidden', 'true');
    dot.style.cssText = 'position:absolute;right:7px;bottom:5px;width:8px;height:8px;border:1px solid #000;border-radius:50%;background:#159447;box-sizing:border-box';
    button.append(dot);
  }
  search.querySelector('[data-ghs-menu]').addEventListener('click', () => {
    close(search);
    headerControl('[data-testid="header-navigation-menu-button"]')?.click();
  });
  search.querySelector('[data-ghs-announcement]').addEventListener('click', () => {
    close(search);
    headerControl('section[role="banner"] button[aria-haspopup="dialog"]')?.click();
  });
  // The archived submit adapter need not handle this shared native form.
  search.querySelector('form').addEventListener('submit', event => {
    event.preventDefault();window.location.assign(local('/search') + '?q=' + encodeURIComponent(input.value.trim()) + '&type=product');
  });
  /* Spinner, per the archived Spinner component: a bordered circle, dark on the
     black checkout button and light on a quantity control. */
  function spinner(theme) {
    const node = element('div','ghs-spinner ghs-spinner--' + theme);
    node.setAttribute('aria-hidden','true');
    return node;
  }
  /* The reference states progress in one place only — the checkout button swaps
     its label for a spinner (archived 1o91brv2ctepr.js, CartDrawerHeader) — so
     nothing inside the panel moves while the cart is in flight. */
  const checkoutLabel = checkout.textContent.trim();
  function setCartBusy(busy) {
    if (busy) {checkout.replaceChildren(spinner('dark'));checkout.setAttribute('aria-busy','true');}
    else {checkout.replaceChildren(document.createTextNode(checkoutLabel));checkout.removeAttribute('aria-busy');}
  }
  async function loadCart() {
    const version = ++cartRequest;
    setCartBusy(true);
    checkout.setAttribute('aria-disabled','true');
    try {
      const response = await fetch(local('/cart.js'), {cache:'no-store'});
      if (!response.ok) throw new Error('Cart unavailable');
      const data = await response.json();
      if (version !== cartRequest) return;
      cartData = data; cartStatus.textContent = ''; setCartBusy(false); renderCart();
    } catch {
      setCartBusy(false);
      cartStatus.replaceChildren(element('span','',text('Sepet yüklenemedi. ','Unable to load your cart. ')));
      const retry = element('button','',text('Tekrar dene','Retry'));retry.addEventListener('click',loadCart);cartStatus.append(retry);
    }
  }
  function renderCart() {
    const saved = window.GiestoWishlist?.items || [];
    syncCartCount(cartData?.item_count || 0);
    cart.querySelector('#ghs-cart-title').textContent = text('Sepetim','Cart') + ' (' + money(cartData?.total_price || 0) + ')';
    checkout.setAttribute('aria-disabled',String(!cartData?.item_count));
    checkout.tabIndex = cartData?.item_count ? 0 : -1;
    cart.querySelector('[data-ghs-tab=cart] [data-ghs-tab-label]').textContent = text('Sepetim','Cart') + ' (' + (cartData?.item_count || 0) + ')';
    cart.querySelector('[data-ghs-tab=saved] [data-ghs-tab-label]').textContent = text('Favoriler','Wishlist') + ' (' + saved.length + ')';
    for (const tab of cart.querySelectorAll('[data-ghs-tab]')) {const selected = tab.dataset.ghsTab === activeTab;tab.setAttribute('aria-selected',String(selected));tab.tabIndex = selected ? 0 : -1;}
    itemsPanel.setAttribute('aria-labelledby',activeTab === 'cart' ? 'ghs-cart-tab' : 'ghs-saved-tab');
    itemsPanel.dataset.ghsPanel = activeTab;
    itemsPanel.replaceChildren();
    renderRecent();
    if (activeTab === 'saved') {renderTotals();renderWishlist(saved);return;}
    const items = cartData?.items || [];
    if (!items.length) {
      renderTotals();
      const empty = element('div','ghs-cart__empty');
      const media = element('div','ghs-cart__empty-media');
      media.setAttribute('aria-hidden','true');
      empty.append(media);
      empty.append(element('h3','',text('Sepetiniz boş','Your cart is empty')));
      const button = element('button','',text('Alışverişe devam et','Continue shopping'));button.addEventListener('click',()=>close(cart));empty.append(button);itemsPanel.append(empty);return;
    }
    for (const item of items) {
      // ProductSummaryItem structure from source/209vc7rb0jqic.js.
      const row=element('article','ghs-cart__item'), media=element('a','ghs-cart__media');
      media.href=productLink(item.url || '/products/'+item.handle);
      const imageUrl=item.featured_image?.url || item.image;
      if(imageUrl){const img=element('img');img.src=imageUrl;img.alt=item.product_title || item.title;media.append(img);}
      const info=element('div','ghs-cart__info'), top=element('div','ghs-cart__item-top'), link=element('a','ghs-cart__product-link');link.href=media.href;
      link.append(element('h3','',item.product_title || item.title));
      link.append(element('p','ghs-cart__price',activeTab==='cart'?money(item.final_price):item.price));
      const favourite=element('button','ghs-cart__favourite');favourite.type='button';
      const id=String(item.product_id || item.id),isSaved=saved.some(entry=>String(entry.id)===id);
      favourite.setAttribute('aria-label',text(isSaved?'Favorilerden çıkar':'Favorilere ekle',isSaved?'Remove from wishlist':'Add to wishlist'));favourite.setAttribute('aria-pressed',String(isSaved));favourite.append(icon(isSaved?'header-wishlist-active':'header-wishlist'));
      favourite.addEventListener('click',()=>{if(isSaved)window.GiestoWishlist?.remove(id);else window.GiestoWishlist?.add({id,handle:item.handle,title:item.product_title || item.title,url:media.href,image:imageUrl,price:money(item.final_price)});renderCart();});
      top.append(link,favourite);info.append(top);
      const bottom=element('div','ghs-cart__item-bottom');
      if(activeTab==='cart'){
        bottom.append(element('p','ghs-cart__variant',(item.variant_title || '').replaceAll(' / ',' - ').replace('Default Title','')));
        const quantity=element('div','ghs-cart__quantity');
        for(const delta of [-1,1]){
          const button=element('button');button.type='button';
          button.setAttribute('aria-label',text(delta===1?'Adedi artır':item.quantity===1?'Kaldır':'Adedi azalt',delta===1?'Increase quantity':item.quantity===1?'Remove':'Decrease quantity')+': '+item.product_title);
          button.append(icon(delta===1?'navigate-more':item.quantity===1?'navigate-remove':'navigate-less'));
          button.addEventListener('click',()=>{
            // As in the archived CartItem: the line marks itself pending, both of
            // its controls go disabled and the pressed one becomes a spinner.
            // Nothing outside this row changes, so the panel never reflows.
            if (quantity.dataset.ghsPending) return;
            quantity.dataset.ghsPending = '';
            for (const control of quantity.querySelectorAll('button')) control.disabled = true;
            button.replaceChildren(spinner('light'));
            changeItem(item.key,item.quantity+delta);
          });quantity.append(button);
          if(delta===-1)quantity.append(element('span','',item.quantity));
        }
        bottom.append(quantity);
      }
      info.append(bottom);row.append(media,info);itemsPanel.append(row);
    }
    renderTotals();
  }
  /* How far this cart is from free delivery, in minor units, or null when the
     promise does not apply: no threshold, nothing to ship, or a presentment
     currency the threshold was not set in. Measured against total_price, the
     after-discount amount Shopify's own price-based rates compare. */
  function freeShippingRemaining(){
    if(!freeShippingThreshold||!cartData?.requires_shipping)return null;
    const currency=cartData.currency||host.dataset.currency;
    if(host.dataset.shopCurrency&&currency&&currency!==host.dataset.shopCurrency)return null;
    return Math.max(0,freeShippingThreshold-cartData.total_price);
  }
  function renderTotals(){
    const summary=cart.querySelector('[data-ghs-totals]');
    summary.hidden=activeTab!=='cart'||!cartData?.item_count;summary.replaceChildren();
    if(summary.hidden)return;
    const remaining=freeShippingRemaining();
    /* What delivery costs this cart, in minor units: the flat fee until the
       threshold is reached, nothing after it. `null` is the promise not
       applying at all — a currency the amounts were not entered in — which is
       the one case still left to checkout, and which contributes nothing to the
       total because we do not know what it will be. This mirrors
       `applied_cents` in `giesto-free-shipping.liquid`. */
    const shipping=remaining===null?null:(remaining>0?shippingFee:0);
    const values=element('dl','ghs-cart__totals-values');
    const add=(label,value)=>{const row=element('div');row.append(element('dt','',label),element('dd','',value));values.append(row);};
    add(text('Ara toplam','Order value'),money(cartData.original_total_price));
    if(cartData.total_discount)add(text('İndirim','Discount'),'− '+money(cartData.total_discount));
    /* What is still missing for free delivery is said on the delivery row
       itself. The reference has no promise block above the totals, and a
       filled progress track there reads as a rule it does not have either. */
    let delivery=text('Kargo','Delivery');
    if(remaining)delivery+=' ('+text('Ücretsiz kargo için '+money(remaining)+' daha ekleyin','Add '+money(remaining)+' more for free delivery')+')';
    add(delivery,cartData.requires_shipping
      ?(shipping===null
        ?text('Ödeme adımında hesaplanır','Calculated at checkout')
        :(shipping===0?text('Ücretsiz','Free'):money(shipping)))
      :money(0));
    /* Delivery is part of the figure this row calls a total; `total_price` is
       Shopify's merchandise total and never includes it. */
    const total=element('div','ghs-cart__total');total.append(element('span','',text('Toplam','Order total')),element('span','',money(cartData.total_price+(shipping||0))));
    summary.append(values,total);
  }

  /* The wishlist tab is the reference's own block stack rather than a list of
     cart rows: a sign-in panel that guests see and members do not
     (WishlistPromoBlock over BulletCTAPanel, archived
     2337577c3e6efc68c4628922.js and 1535e43a4506bf6d528aeeaf.js), the
     "recently added" carousel of quickshop cards, and the link through to the
     full wishlist. An empty list keeps the panel and swaps the carousel for
     the reference's empty copy. */
  let wishlistRequest = 0;
  async function renderWishlist(saved) {
    const version = ++wishlistRequest;
    itemsPanel.replaceChildren();
    if (host.dataset.customer !== 'true') itemsPanel.append(wishlistPromo());
    if (!saved.length) {itemsPanel.append(wishlistEmpty());return;}

    // The rail is a teaser of the most recent saves, as its heading says; the
    // whole list lives on the wishlist page behind the call to action.
    const recent = saved.slice(0, 8);
    const products = await Promise.all(recent.map(async item => {
      const handle = wishlistHandle(item);
      if (!handle) return {item, variants: []};
      try {
        const response = await fetch(local('/products/' + encodeURIComponent(handle) + '.js'), {cache:'no-store'});
        if (!response.ok) return {item, variants: []};
        const product = await response.json();
        return {item, product, variants: Array.isArray(product.variants) ? product.variants : []};
      } catch { return {item, variants: []}; }
    }));
    if (version !== wishlistRequest || activeTab !== 'saved') return;

    itemsPanel.append(wishlistCarousel(products), wishlistCta());
  }
  /* Saved items do not all carry a handle — one stored before the field existed,
     or added by a control that never set it, has only its URL — and without a
     handle there is no product to fetch, which is what left the size drawer
     with nothing to list. */
  function wishlistHandle(item) {
    if (item.handle) return item.handle;
    const path = String(item.url || '');
    return path.split('/products/')[1]?.split(/[?#]/)[0] || '';
  }
  function wishlistPromo() {
    const wrap = element('div','ghs-wishlist__promo-wrap');
    const panel = element('div','ghs-wishlist__promo');
    panel.append(element('h3','ghs-wishlist__promo-heading',text(
      'Üye olan müşteriler favori listesinin tamamından yararlanır',
      'Signed-in members get the full wishlist experience')));
    const list = element('ul','ghs-wishlist__promo-list');
    for (const bullet of [
      text('Kaydettiğiniz ürünleri asla kaybetmeyin','Never lose your saved items'),
      text('Ürünleri tüm cihazlarınıza kaydedin','Save items across all your devices'),
      text('Favori listenizin tamamına erişin','Access your full wishlist'),
    ]) {
      const row = element('li');
      const mark = element('span','ghs-wishlist__promo-check');mark.append(icon('miscellaneous-check-filled'));
      row.append(mark,element('p','',bullet));list.append(row);
    }
    const action = element('a','ghs-wishlist__promo-action',text('Giriş yapın / Üye olun','Sign in / Become a member'));
    action.href = host.dataset.loginUrl || local('/account/login');
    panel.append(list,action);wrap.append(panel);return wrap;
  }
  function wishlistEmpty() {
    const empty = element('div','ghs-cart__empty');
    const media = element('div','ghs-cart__empty-media');media.setAttribute('aria-hidden','true');
    empty.append(media,element('h3','',text('Favorileriniz boş','Your wishlist is empty')));
    const button = element('button','',text('Alışverişe devam et','Continue shopping'));
    button.addEventListener('click',()=>close(cart));empty.append(button);
    return empty;
  }
  function wishlistCta() {
    const wrap = element('div','ghs-wishlist__cta');
    const link = element('a','',text('Favorilere devam et','Continue to wishlist'));
    link.href = local('/pages/favori');
    wrap.append(link);return wrap;
  }
  function wishlistCarousel(entries) {
    const section = element('section','ghs-wishlist');
    const head = element('div','ghs-wishlist__head');
    head.append(element('h3','',text('Favorilere son eklenenler','Recently added to wishlist')));
    const rail = element('ul','ghs-wishlist__rail');rail.setAttribute('role','list');
    // The reference only draws the arrows once the rail has more than it can
    // show, and hides them below its tablet breakpoint.
    const nav = element('div','ghs-wishlist__nav');
    const controls = [];
    for (const direction of [-1, 1]) {
      const button = element('button');button.type='button';
      button.setAttribute('aria-label',text(direction === 1 ? 'Sonraki' : 'Önceki', direction === 1 ? 'Next' : 'Previous'));
      button.append(icon(direction === 1 ? 'navigate-arrow-right' : 'navigate-arrow-left'));
      button.addEventListener('click',()=>{
        const step = rail.querySelector('li')?.getBoundingClientRect().width || rail.clientWidth;
        rail.scrollBy({left: step * direction, behavior: 'smooth'});
      });
      nav.append(button);controls.push(button);
    }
    const syncNav = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      nav.hidden = max <= 1;
      controls[0].disabled = rail.scrollLeft <= 1;
      controls[1].disabled = rail.scrollLeft >= max - 1;
    };
    rail.addEventListener('scroll', syncNav, {passive: true});
    head.append(nav);section.append(head, rail);

    for (const entry of entries) rail.append(wishlistCard(entry));
    requestAnimationFrame(syncNav);
    return section;
  }
  function wishlistCard({item, product, variants}) {
    const slide = element('li');
    const card = element('article','ghs-wishlist__card');
    card.dataset.gsSizeSource = '';
    const handle = wishlistHandle(item);
    const href = productLink(item.url || '/products/' + handle);
    const media = element('a','ghs-wishlist__card-media');media.href = href;media.setAttribute('aria-hidden','true');media.tabIndex = -1;
    const imageUrl = item.image || product?.featured_image || product?.images?.[0];
    if (imageUrl) {const img=element('img');img.src=imageUrl;img.alt='';img.loading='lazy';media.append(img);}
    const info = element('a','ghs-wishlist__card-info');info.href = href;
    info.append(element('span','',item.title || product?.title || ''));
    info.append(element('span','ghs-wishlist__card-price',item.price || (product ? money(product.price) : '')));

    // The + opens the shared size picker, the same control the recently-viewed
    // rail uses; the filled heart takes the product back off the wishlist.
    const actions = element('div','ghs-wishlist__card-actions');
    const add = element('button','ghs-wishlist__card-add');add.type='button';
    add.setAttribute('aria-label',text('Beden seç: ','Choose size: ') + (item.title || ''));
    add.append(icon('navigate-plus'));
    add.dataset.productId = String(product?.id || item.id || '');
    add.dataset.productUrl = href;
    add.dataset.productTitle = item.title || product?.title || '';
    const sizePosition = (product?.options || []).findIndex(option => /size|beden/i.test(option.name || option));
    add.dataset.sizePosition = String(sizePosition < 0 ? 0 : sizePosition);
    add.dataset.gacSizeTrigger = '';
    const variantsData = element('script');variantsData.type='application/json';variantsData.dataset.gacVariants='';
    variantsData.textContent = JSON.stringify(variants.map(variant => ({id:variant.id, available:variant.available, options:variant.options})));
    const favourite = element('button','ghs-wishlist__card-fav');favourite.type='button';
    favourite.setAttribute('aria-label',text('Favorilerden çıkar','Remove from wishlist'));
    favourite.setAttribute('aria-pressed','true');
    favourite.append(icon('header-wishlist-active'));
    favourite.addEventListener('click',()=>{window.GiestoWishlist?.remove(String(item.id));renderCart();});
    actions.append(add, element('span','ghs-wishlist__card-divider'), favourite);
    card.append(media, info, variantsData, actions);slide.append(card);return slide;
  }
  async function renderRecent() {
    const version = ++recentRequest;
    if (!recent || !recentRail || activeTab !== 'cart') {
      if (recent) recent.hidden = true;
      return;
    }
    const history = readRecent().slice(0,matchMedia('(min-width:1025px)').matches?8:6);
    if (!history.length) {recent.hidden = true;recentRail.replaceChildren();return;}
    try {
      const products = (await Promise.all(history.map(async item => {
        const response = await fetch(local('/products/' + encodeURIComponent(item.handle) + '.js'), {cache:'no-store'});
        return response.ok ? response.json() : null;
      }))).filter(Boolean);
      if (version !== recentRequest || activeTab !== 'cart') return;
      recentRail.replaceChildren();
      for (const product of products) {
        const card = element('article','ghs-recent__card');
        card.dataset.gsSizeSource = '';
        card.setAttribute('role','listitem');
        const link = element('a');link.href = productLink(product.url || '/products/' + product.handle);link.setAttribute('aria-label',product.title || '');
        const imageUrl = product.featured_image || product.images?.[0];
        if (imageUrl) {const img=element('img');img.src=imageUrl;img.alt=product.title || '';img.loading='lazy';link.append(img);}
        const variants = Array.isArray(product.variants) ? product.variants : [];
        const variantsData = element('script');variantsData.type='application/json';variantsData.dataset.gacVariants='';variantsData.textContent=JSON.stringify(variants.map(item=>({id:item.id,available:item.available,options:item.options})));
        const add = element('button','ghs-recent__add','+');add.type='button';add.setAttribute('aria-label',text('Beden seç: ','Choose size: ') + (product.title || ''));
        add.dataset.productId=String(product.id || '');add.dataset.productUrl=link.href;add.dataset.productTitle=product.title || '';
        const sizePosition = (product.options || []).findIndex(option => /size|beden/i.test(option.name || option));
        add.dataset.sizePosition=String(sizePosition < 0 ? 0 : sizePosition);
        add.dataset.gacSizeTrigger='';
        link.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();add.click();});
        card.append(link,variantsData,add);recentRail.append(card);
      }
      recent.hidden = !products.length;
    } catch {recent.hidden=true;recentRail.replaceChildren();}
  }
  async function changeItem(key, quantity) {
    setCartBusy(true);
    try {
      const response = await fetch(local('/cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message);
      cartData = data;
      document.dispatchEvent(new CustomEvent('giesto:cart:change',{detail:data}));
    } catch (error) {
      // The reference logs and re-renders; a line of copy in the panel would
      // push the totals down over a quantity Shopify has already clamped.
      console.error('giesto-header-surfaces:', error);
    }
    setCartBusy(false);
    renderCart();
  }
  for (const tab of cart.querySelectorAll('[data-ghs-tab]')) {
    tab.addEventListener('click',()=>{activeTab=tab.dataset.ghsTab;renderCart();});
    tab.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();activeTab = activeTab === 'cart' ? 'saved' : 'cart';renderCart();cart.querySelector('[aria-selected=true]').focus();});
  }
  document.addEventListener('giesto:wishlist:change',()=>{if(cart.open)renderCart();});
  document.addEventListener('giesto:cart:change',event=>{const data=event.detail;if(data?.item_count !== undefined)syncCartCount(data.item_count);if(cart.open)loadCart();});
  document.addEventListener('giesto:cart:open',event=>{activeTab='cart';show(cart,event.detail?.trigger || headerControl('[data-testid=header-cart]'));loadCart();});
  document.addEventListener('shopify:cart:lines-update',event=>{
    if(!(event.promise instanceof Promise))return;
    const fromCartSize=Boolean(document.querySelector('#GiestoStoreSizePicker[data-cart][open]'));
    event.promise.then(result=>{
      if(result?.detail?.didError)return;
      if(event.action==='add'&&fromCartSize)close(cart);
      loadCart();
    }).catch(()=>{});
  });
  document.addEventListener('cart:update',()=>fetch(local('/cart.js'),{cache:'no-store'}).then(response=>response.ok?response.json():null).then(data=>{if(data)syncCartCount(data.item_count || 0);}).catch(()=>{}));
  rememberCurrentProduct();
  syncAccountState();
  fetch(local('/cart.js'),{cache:'no-store'}).then(response=>response.ok?response.json():null).then(data=>{if(data)syncCartCount(data.item_count || 0);}).catch(()=>{});
  window.addEventListener('pagehide',()=>{search.close();cart.close();account?.close();});
})();
